export default {
  name: 'Kitchen',
  id: 'Kitchen',
  data: [
    // {
    //   title: 'High heat on the stovetop left unattended.',
    //   icon1: '/static/svgs/kitchen/oven.svg',
    //   answers: [
    //     'Turn off the stove immediately.',
    //   ],
    //   correctAnswerIndex: 0,
    //   position: {
    //     x: -0.8,
    //     y: 0.2,
    //     z: 1.35
    //   },
    //   completed: false
    // },
    {
      title: 'Grease has collected on the range hood and filter.',
      icon1: '/static/svgs/kitchen/kitchen.svg',
      answers: [
        'In case of power loss during a storm, turn your refrigerator and freezer to their coldest setting. Don’t eat food that has warmed past 40° F.',
      ],
      correctAnswerIndex: 2,
      position: {
        x: -0.8,
        y: 0.5,
        z: 1.25
      },
      completed: false
    },
    // {
    //   title: 'A fire extinguisher is missing from the kitchen.',
    //   icon1: '/static/svgs/kitchen/fire-extinguisher.svg',
    //   answers: [
    //     'Have a bottle of water always available next to the stove in case you need to douse a flame.',
    //   ],
    //   correctAnswerIndex: 1,
    //   position: {
    //     x: -0.25,
    //     y: 0.4,
    //     z: 0
    //   },
    //   completed: false
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/residential/firstFloor/Kitchen.js